import { CORNER_RADII, type CornerRadius } from '@lib/enums/corner-radius.enum'
import { FONT_FAMILIES, type FontFamily } from '@lib/enums/font-family.enum'
import type { SegmentedOption } from '@/components/ui/segmented-control'

/** How the brand settings name each corner radius; `medium` is PixelSign's. */
export const CORNER_LABELS = {
  none: 'Square',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
} as const satisfies Record<CornerRadius, string>

/** How the brand settings name each font; `inter` is PixelSign's. */
export const FONT_LABELS = {
  inter: 'Inter',
  system: 'System',
} as const satisfies Record<FontFamily, string>

export const CORNER_OPTIONS: readonly SegmentedOption<CornerRadius>[] = CORNER_RADII.map((value) => ({
  value,
  label: CORNER_LABELS[value],
}))

export const FONT_OPTIONS: readonly SegmentedOption<FontFamily>[] = FONT_FAMILIES.map((value) => ({
  value,
  label: FONT_LABELS[value],
}))
